// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SvIZo","placeholdersHeader":"styles_placeholdersHeader__3T63T","editorStyle":"styles_editorStyle__39zP_","placeholdersBox":"styles_placeholdersBox__lEFoB"};